import { useState } from "react";
import { CalendarDays } from "lucide-react";

var PERIOD_OPTIONS = [
  { value: "month", label: "Este Mes" },
  { value: "quarter", label: "Trimestre" },
  { value: "semester", label: "Semestre" },
  { value: "year", label: "Este Ano" },
  { value: "custom", label: "Personalizado" },
];

export default function ReportFilters({ onFilter }) {
  var periodState = useState("semester");
  var period = periodState[0];
  var setPeriod = periodState[1];
  var startState = useState("");
  var startDate = startState[0];
  var setStartDate = startState[1];
  var endState = useState("");
  var endDate = endState[0];
  var setEndDate = endState[1];

  function calcDates(p) {
    var now = new Date();
    var s, e;
    e = now.toISOString().split("T")[0];
    if (p === "month") {
      s = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split("T")[0];
    } else if (p === "quarter") {
      s = new Date(now.getFullYear(), now.getMonth() - 2, 1).toISOString().split("T")[0];
    } else if (p === "semester") {
      s = new Date(now.getFullYear(), now.getMonth() - 5, 1).toISOString().split("T")[0];
    } else if (p === "year") {
      s = new Date(now.getFullYear(), 0, 1).toISOString().split("T")[0];
    } else {
      return null;
    }
    return { start_date: s, end_date: e };
  }

  function handlePeriodChange(val) {
    setPeriod(val);
    if (val !== "custom") {
      var dates = calcDates(val);
      if (dates) onFilter(dates);
    }
  }

  function handleApply() {
    if (period === "custom" && startDate && endDate) {
      onFilter({ start_date: startDate, end_date: endDate });
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6" data-testid="report-filters">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <CalendarDays className="w-4 h-4" />
        <span className="font-medium">Periodo:</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {PERIOD_OPTIONS.map(function(opt) {
          var active = period === opt.value;
          return (
            <button
              key={opt.value}
              data-testid={"filter-" + opt.value}
              onClick={function() { handlePeriodChange(opt.value); }}
              className={"px-3 py-1.5 rounded-lg text-xs font-medium transition-all " + (active ? "bg-[#3B82F6] text-white shadow-sm" : "bg-gray-100 text-gray-600 hover:bg-gray-200")}
            >{opt.label}</button>
          );
        })}
      </div>
      {period === "custom" && (
        <div className="flex items-center gap-2">
          <input type="date" value={startDate} onChange={function(e) { setStartDate(e.target.value); }} className="px-2 py-1.5 border rounded-lg text-xs" data-testid="filter-start-date" />
          <span className="text-gray-400 text-xs">ate</span>
          <input type="date" value={endDate} onChange={function(e) { setEndDate(e.target.value); }} className="px-2 py-1.5 border rounded-lg text-xs" data-testid="filter-end-date" />
          <button onClick={handleApply} className="px-3 py-1.5 rounded-lg text-xs font-medium bg-[#3B82F6] text-white" data-testid="filter-apply">Aplicar</button>
        </div>
      )}
    </div>
  );
}
